import {Component, OnInit, Input, NgModule, NO_ERRORS_SCHEMA, AfterViewInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Archive} from '../archive';
import {UsersShowComponent} from '../../users/users-show/users-show.component';
import {ArchiveService} from '../archive.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {appConfig} from "../../../../app.config";
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, DropdownModule, MessagesModule} from "primeng/primeng";
import {Http} from "@angular/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {UserPictureComponent} from "../../../../components/user-picture";
import {RecordDataComponent} from "../../../../components/record-data";
import {AppArcComponent} from "../../../../components/app-arc";
import {MyInputsModule} from "../../../../my-inputs/my-inputs.module";
import {BranchService} from "../../branches/branch.service";
import {UserService} from '../../../../services';


@NgModule({
    imports: [CommonModule, FormsModule, DropdownModule, MessagesModule,MyInputsModule,
        ReactiveFormsModule, ConfirmDialogModule, TranslateModule.forChild()
    ],
    declarations: [
        ArchiveShowComponent
    ],
    entryComponents: [
        ArchiveShowComponent
    ],
    exports: [],
    providers: [SharedService, ArchiveService, MessageService, ConfirmationService],
    schemas: [NO_ERRORS_SCHEMA]
})

@Component({
    selector: 'app-archive-show',
    templateUrl: './archive-show.component.html',
    styleUrls: ['./archive-show.component.scss'],
    providers: [ArchiveService, ConfirmationService, MessageService]
})

export class ArchiveShowComponent implements OnInit, AfterViewInit {
    id: string;
    archive =  new Archive();
    @Input() refShow;

    allarchive :any[] = [];

    applog: AppLogComponent;
    
    @Input() scrId;
    modalRef: NgbModalRef;

    @Input() delId;
    @Input() oldData;
    @Input() newData;
    @Input() newDatap;
    @Input() modelName;

    form: FormGroup;
    private sub: any;
    msgs: Message[] = [];
    public imgUrl = appConfig.publicUrl;
    private _editButton: any;
    private _deleteButton: any;
    private _newButton: any;
    private _printButton: any;
    private _searchButton: any;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sharedservice: SharedService,
                private archiveService: ArchiveService,
                private userService: UserService,
                private modalService: NgbModal,
                public activeModal: NgbActiveModal,
                public translate: TranslateService,
                private confirmationService: ConfirmationService,
                private messageService: MessageService) {
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        this.msgs =[];

        if (userdata && userdata.lang) {
            this.translate.use(userdata.lang);
        }
        this.sharedservice.setTitle(this.route.snapshot.data.title);
        this.sharedservice.setButtons([
            {label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton'},
            {label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton'},
            // {label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton'},
            {label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton'},
            {label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton'},

        ]);
        this.sharedservice.setModelName('archive');
        this.sharedservice.setItemShow(ArchiveShowComponent);

    }
    recordData() {
        const options: NgbModalOptions = {
            beforeDismiss: () => {
                return true;
            }
        };
        const modalRef = this.modalService.open(RecordDataComponent, options);
        modalRef.componentInstance.refRec = this.archive;
        modalRef.componentInstance.rowId = '';

    }

    ngAfterViewInit() {
        const color = localStorage.getItem("color")?localStorage.getItem("color"):'';

        localStorage.removeItem("color");

        this.form.patchValue({color:color,color_pattern:color});
        if(!this.scrId && !this.oldData && !this.scrId) {
            this._editButton = document.getElementById('editButton');
            this._deleteButton = document.getElementById('deleteButton');
            this._newButton = document.getElementById('newButton');
            this._printButton = document.getElementById('printButton');
            this._searchButton = document.getElementById('searchButton');


            if (this._editButton) {
                this._editButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/archive/edit', this.id]);
                });
            }
            if (this._deleteButton) {

                this._deleteButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.deleteArchive(this.archive);
                });
            }
            if (this._newButton) {

                this._newButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/archive']);
                });

            }
            if (this._searchButton) {
                this._searchButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/archive/search']);
                });

            }
        }
    }

    ngOnInit() {
        this.msgs =[];

        this.archiveService.getAllArchive().subscribe(
            data => {
                this.allarchive = data.archiveslist;
            });

        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
        });

        this.form = new FormGroup({
            id: new FormControl({value: '', disabled: true}),
            name: new FormControl({value: '', disabled: true}),
            color: new FormControl({value: '', disabled: true}),
            color_pattern: new FormControl({value: '', disabled: true}),
        });

        if (this.id) {
            this.msgs =[];
            this.activeModal.dismiss('');
            this.oldData = false;
            this.newData = false;
            this.delId = false;
            this.newDatap = true;
            localStorage.removeItem('filter');
            const msg = JSON.parse(localStorage.getItem('showMessages'));
            if (msg) {
                localStorage.removeItem('showMessages');
                this.msgs = msg;
            }
            this.archiveService.getById(this.id).subscribe(
                archive => {
                    this.id = archive.id;
                    this.archive = archive;
                    this.form.patchValue({
                        id: archive.id,
                        name: archive.name,
                        color: archive.color,
                        color_pattern: archive.color,
                    });
                }, error => {
                    console.log(error);
                }
            );
        }
        if (this.scrId) {
            this.oldData = false;
            this.newData = false;
            this.delId = false;

            this.archiveService.getById(this.scrId).subscribe(
                archive => {
                    this.id = archive.id;
                    this.archive = archive;
                    this.form.patchValue({
                        id: archive.id,
                        name: archive.name,
                        color: archive.color,
                        color_pattern: archive.color,
                    });
                }, error => {
                    console.log(error);
                }
            );
        }
        
        if(this.delId){
            this.oldData = false;
            this.newData = false;
            this.newDatap = !this.newDatap ;
            this.archiveService.getTrashedById(this.delId).subscribe(
                archive => {
                    this.id = archive.id;
                    this.archive = archive;
                    this.form.patchValue({
                        id: archive.id,
                        name: archive.name,
                        color: archive.color,
                        color_pattern: archive.color,
                    });
                }, error => {
                    console.log(error);
                }
            );
        }

        if (this.oldData && this.newData) {
            this.archive = this.newData;
            this.form.patchValue({
                id: this.newData.id,
                name: this.newData.name,
                color: this.newData.color,
                color_pattern: this.newData.color,
            });
        }
    }

    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button) {
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        if (userRoles.indexOf('setting.archive.' + role) >= 0) {
            return true;
        }
        return false;
    }

    deleteArchive(archive: Archive) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Delete'),
            message: this.translate.instant('Are you sure of delete ?'),
            icon: 'fa fa-trash',
            accept: () => {
                if (archive) {
                    this.archiveService.delete(archive.id).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Delete completed')
                            });
                            setTimeout(()=>{
                                this.router.navigate(['/archive']);
                        },1000);
                            localStorage.setItem('showMessages', JSON.stringify(this.msgs));

                        }
                    );
                }
            }
        });
    }

    recoverEdit(archive: Archive) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Edit'),
            message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
            icon: 'fa fa-undo',
            accept: () => {
                if (archive) {
                    this.archiveService.update(archive).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Data returned')
                            });
                            this.activeModal.close('done');
                            this.router.navigate(['/archive/show', archive.id]);
                        }
                    );
                }
            }
        });
    }

    undotrashed() {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Delete'),
            message: this.translate.instant('Are you sure about recover deleted item?'),
            icon: 'fa fa-undo',
            accept: () => {
                if (this.delId) {
                    this.archiveService.restoreTrashedById(this.delId).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Deleted organization recovered')
                            });
                            this.activeModal.dismiss('close click');
                            this.router.navigate(['/archive/list']);
                        }
                    );
                }
            }
        });
    }


  showattachement(row_id: string) {
    if (row_id) {
      const options: NgbModalOptions = {

        beforeDismiss: () => {
          return true;
        }
      };
      const modalRef = this.modalService.open(AppArcComponent, options);
      modalRef.componentInstance.rowId = row_id;
      modalRef.componentInstance.screenName = this.modelName;
    }
  }
  showHistory(row_id: string) {
    if (row_id) {
      const modalRef = this.modalService.open(AppLogComponent);
        modalRef.componentInstance.refShow = ArchiveShowComponent;

        modalRef.componentInstance.rowId = row_id;
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/views/setting/archive/archive-show/archive-show.component.ts